export class SettingsIncidentReport {
    static fromExistingData(data): SettingsIncidentReport {
        const settingsIncidentReport = new SettingsIncidentReport();
        if (data.id) settingsIncidentReport.id = data.id;
        if (data.name) settingsIncidentReport.name = data.name;
        if (data.buildings) settingsIncidentReport.buildings = data.buildings.map(b => ({...b, itemName: b.name}));
        if (data.staffNotificationSettings) settingsIncidentReport.staffNotificationSettings = data.staffNotificationSettings;
        if (data.createdAt) settingsIncidentReport.createdAt = data.createdAt;
        if (data.createdBy) settingsIncidentReport.createdBy = data.createdBy.fullName;
        settingsIncidentReport.isCanEdit = data.isCanEdit;
        settingsIncidentReport.isCanDelete = data.isCanDelete;
        return settingsIncidentReport;
    }

    constructor(
        public id: number = null,
        public name: string = '',
        public buildings: Array<any> = [],
        public staffNotificationSettings: Array<any> = [],
        public createdBy: string = '',
        public createdAt: string = '',
        public checked: boolean = false,
        public isCanEdit: boolean = true,
        public isCanDelete: boolean = true
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/SettingsIncidentReport.ts